import React, {useState, useEffect} from 'react'

const FigmdCaptcha = props => {
    const [text, settext] = useState([])

    useEffect(() => {
        setData()
    }, [props.toggleRefresh])

    let image
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" height="${
        props.height
    }" width="${props.width}">${text.join()}</svg>`
    image = btoa(svg)

    const setData = () => {
        let length = props.length

        let originText = []
        if (props.text !== '') {
            length = props.text.length
        }

        let newtext = []
        for (var i = 0; i < length; i++) {
            let char = possible.charAt(Math.floor(Math.random() * possible.length))
            if (props.text !== '') {
                char = props.text[i]
            }

            newtext.push(
                `<text
                      font-family="${props.fontFamily}"
                      font-size="${props.fontSize}"
                      x="${props.paddingLeft * i}"
                      y="${props.paddingTop}"
                      fill="${
                          props.textColor
                              ? props.textColor
                              : '#' + (((1 << 24) * Math.random()) | 0).toString(16)
                      }"
                      transform="rotate(${Math.random() * (5 - 0) + 0})"
                  >${char}</text>`
            )
            originText.push(char)
        }
        settext(newtext)
        props.result(originText.join(''))
    }

    return (
        <div style={{height: props.height, width: props.width}}>
            <img
                style={{
                    background: props.background,
                    height: '100%',
                    width: '100%',
                    paddingLeft: '8px',
                }}
                src={`data:image/svg+xml;base64,${image}`}
                alt=""
            />
        </div>
    )
}

FigmdCaptcha.defaultProps = {
    height: 40,
    width: 130,
    textColor: '#666666',
    fontFamily: 'Roboto, Verdana, sans-serif',
    fontWaight: 'bold',
    fontSize: '30',
    paddingLeft: '25',
    paddingTop: '30',
    length: '5',
    background: 'none',
    text: '',
    toggleRefresh: false,
}

export default FigmdCaptcha
